export default [
  '/login',
]